export enum MedicalLeaveSubtypeEnum {
    it_common = "it_common",
    it_work_accident = "it_work_accident",
    maternity_paternity = "maternity_paternity",
    pregnancy_risk = "pregnancy_risk",
    other = "other",
}

export class MedicalLeaveSubtype {
    constructor(
        public readonly key: MedicalLeaveSubtypeEnum,
        public readonly value: string,
    ) {}
}
